// Traducciones en inglés para la sección de suscripción
const subscribe = {
  title: "Subscribe",
  message: "If you want to be the first to know about all new content, give us your email and we will keep you informed. We hope you like it!",
  checkbox: "I have read the <0>privacy policy</0> and accept the terms.",
  buttonSubscribe: "Subscribe",
  buttonBack: "Back",
  warningTitle: "Warning",
  warningMsg: "You must accept the privacy policy and terms in order to subscribe.",
  enterEmailTitle: "Enter your email",
  emailPlaceholder: "Email address",
  success: "Subscription completed successfully!",
  error: "Error while subscribing. Please try again.",
  errorNoEmail: "Please enter your email address."
}; 

export default subscribe; 